export default {
    'contact': require('./Contact.js'),
    'content-card': require('./ContentCard.js'),
    'content-filters': require('./ContentFilters.js'),
    'dock': require('./Dock.js'),
    'films-grid': require('./FilmsGrid.js'),
    'films-vertical-slider': require('./FilmsVerticalSlider.js'),
    'media-cover': require('./MediaCover.js'),
    'media-fullscreen': require('./MediaFullscreen.js'),
    'media': require('./Media.js'),
    'photos-grid': require('./PhotosGrid.js'),
    'site-menu': require('./SiteMenu.js'),
}
